export const DEBUG = false;

// 全局配置api服务器域名


export const pageServerTest = encodeURI("http://testapi.haimaotv.com");
//export const pageServerTest = encodeURI("http://3d5c64f4.r8.cpolar.top/huantv_ott_api_war");
//export const pageServerTest = encodeURI("http://192.168.10.12:8080/huantv_ott_api_war");

export const pageServer = DEBUG ? pageServerTest : encodeURI("https://qapi-moss.huan.tv");
//export const pageServer = DEBUG ? pageServerTest : encodeURI("http://43.136.95.107:8080");

export const versionmb = "red_packet_game_four_";




/**
 * 设置cookie
 * @param name cookie的名称
 * @param value cookie的值
 * @param day cookie的过期时间
 */
 export function setCookie (name, value, day) {
    if (day !== 0) { //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        let expires = day * 24 * 60 * 60 * 1000;
        let date = new Date(+new Date() + expires);
        document.cookie = name + "=" + escape(value) + ";expires=" + date.toUTCString();
    } else {
        document.cookie = name + "=" + escape(value);
    }
};

/**
 * 获取对应名称的cookie
 * @param name cookie的名称
 * @returns {null} 不存在时，返回null
 */
 export function getCookie(name) {
    let arr;
    let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
};

export function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}











// WEBPACK FOOTER //
// ./src/util.js